interface Props {
  index: string;
  en: string;
  title: string;
  desc?: string;
  light?: boolean;
}

export default function SectionHeading({ index, en, title, desc, light }: Props) {
  return (
    <div className="max-w-3xl">
      <p
        className={`flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.28em] ${
          light ? "text-accent-400" : "text-primary-600"
        }`}
      >
        <span className="section-index text-base normal-case tracking-tight text-primary-500/60">
          {index}
        </span>
        <span className="inline-block h-px w-8 bg-current opacity-60" />
        {en}
      </p>
      <h2
        className={`mt-3 font-heading text-3xl font-black tracking-tight md:text-4xl ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-3 text-sm leading-relaxed md:text-base ${
            light ? "text-background-200/85" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}